import {InputSProps} from "@FRAMEWORK/ui/types/d";
import styled from "@yb/styled-px2rem";

interface InputProps extends InputSProps {
	width?: string;
}

const Number = styled.input`
	width: ${props => props.width || "60px"};
	height: 40px;
	border: 0 none;
	border-top: 1px solid var(--line-color);
	border-bottom: 1px solid var(--line-color);
	font-size: 15px;
	text-align: center;
`;

const NumberInput = ({width, ...props}: InputProps) => <Number type="text" width={width} {...props} />;

export default NumberInput;
